import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {User} from '../../types/security/user';
import {Locale} from '../../types/localization/locale';
import {HttpClient} from '@angular/common/http';
import {BaseRestService} from '../common/BaseRestService';
import {Editable} from '../../types/security/editable';

@Injectable()
export class SecurityRestService extends BaseRestService {

  constructor(private http: HttpClient) {
    super('security');
  }

  getCurrentUser(): Observable<User> {
    console.log(this.getEndpoint(['user']));
    return this.http.get<User>(this.getEndpoint(['user']));
  }

  changeLocale(locale: Locale): Observable<any> {
    return this.http.put(this.getEndpoint(['user', 'locale', String(locale.id)]), '');
  }

  getUserPermissions(): Observable<string[]> {
    return this.http.get<string[]>(this.getEndpoint(['user', 'permissions']));
  }

  getEditablePerson(id: number): Observable<Editable> {
    return this.http.get<Editable>(this.getEndpoint(['user', 'permissions', 'consultant', String(id)]));
  }

  getEditableOrganization(id: number): Observable<Editable> {
    return this.http.get<Editable>(this.getEndpoint(['user', 'permissions', 'organization', String(id)]));
  }

  getLogoutUrl(): Observable<string> {
    const requestOptions: Object = {
      responseType: 'text'
    };
    return this.http.get<string>(this.getEndpoint(['user', 'logout']), requestOptions);
  }

}
